import { BankIdRegistrationStore } from "@state/stores/membership/registration";
import { useContext, createContext } from "react";

export const BankIdRegistrationStoreContext = createContext(
	{} as BankIdRegistrationStore
);

export const useBankIdRegistrationStore = () => {
	return useContext(BankIdRegistrationStoreContext);
};
